export default __webpack_public_path__ + "static/media/img-0402-austria-full-face.be41c3e5.png";